import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=5c48ffd2&scoped=true"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=5c48ffd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48ffd2",
  null
  
)

export default component.exports